// © Microsoft Corporation. All rights reserved.

import {
    SocialProps as BaseSocialProps,
    SocialUnhandledProps as BaseSocialUnhandledProps,
    SocialHandledProps,
    SocialManagedClasses
} from "./Social.props";
import { SocialConfigSchema, mockConfig, mockDefaultState, mockState } from "./experience-info";
import manageJss, { ManagedJSSProps } from "@microsoft/fast-jss-manager-react";

import { Social as BaseSocial } from "./Social";
import { DesignSystem } from "@microsoft/fast-components-styles-msft";
import { ExperienceInfo } from "@msnews/core";
import { SocialActions } from "./Social.actions";
import { SocialClassNameContract } from "./Social.classnames";
import { SocialConfig } from "./Social.config";
import { SocialConnector } from "./Social.connector";
import { SocialInspector } from "./Social.inspector";
import { SocialReducer } from "./Social.reducer";
import { SocialState } from "./Social.state";
import { SocialStyles } from "./Social.styles";
import { Subtract } from "utility-types";

// The type returned by manageJss type is very complicated so we'll let the compiler infer the type instead of re-declaring just for the package export
const Social = manageJss(SocialStyles)(BaseSocial);
type Social = InstanceType<typeof Social>;

// Create a valid JSS managed interface that doesn't require managed classes which are provided by the manageJSS HOC
type SocialUnhandledProps = Subtract<BaseSocialUnhandledProps, SocialManagedClasses>;

// Create type for manageJSS HOC styled instance we are exporting
type SocialProps = ManagedJSSProps<BaseSocialProps, SocialClassNameContract, DesignSystem>;

// Define the ExperienceInfo object. This is used by tooling
const ToolingInfo: ExperienceInfo<SocialConfig, SocialState, any, any> = {
    reactComponent: Social,
    experienceConfigSchema: SocialConfigSchema,
    defaultMockState: mockDefaultState,
    mockState: mockState,
    mockConfig: mockConfig,
    inspector: SocialInspector.inspect
};

// Export everything a user might need from this index file
export {
    Social,
    SocialActions,
    SocialConfig,
    SocialConnector,
    SocialProps,
    SocialReducer,
    SocialState,
    SocialClassNameContract,
    SocialHandledProps,
    SocialUnhandledProps,
    ToolingInfo
};